import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackgroundColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.29004 17.3538C7.94591 17.3538 14.1221 17.3538 17.1281 17.3538",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7535 13.9398C16.7535 14.4832 16.313 14.9236 15.7697 14.9236C15.2264 14.9236 14.7859 14.4832 14.7859 13.9398C14.7859 13.3965 15.7109 12.4304 15.7109 12.4304C15.7109 12.4304 16.7535 13.3965 16.7535 13.9398Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7505 7.59911L14.1888 11.0374C14.3841 11.2327 14.3841 11.5493 14.1888 11.7445L11.1586 14.7747C10.9634 14.97 10.6468 14.97 10.4515 14.7747L7.36677 11.6899C7.1715 11.4947 7.1715 11.1781 7.36677 10.9828L10.7505 7.59911ZM10.7505 7.59911L9.7373 6.58594",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1879 14.6367L13.7182 12.1065C14.0332 11.7915 13.8101 11.2529 13.3646 11.2529L8.30415 11.253C7.8587 11.253 7.63563 11.7916 7.95061 12.1066L10.4808 14.6367C10.6761 14.832 10.9926 14.832 11.1879 14.6367Z",
			fill: "black",
			stroke: "black",
			strokeLinecap: "round"
		})
	]
});
export default SvgBackgroundColor;
